import { CustomerApi } from 'conversations/api'
import { Team } from 'shared/typings/teams/Team'

export const fetchTeams = async (): Promise<Team[]> => {
  const response = await CustomerApi.get('/teams')
  return (response.data as Team[]).filter((team) => team.status === 'ENABLED')
}
